import { render, staticRenderFns } from "./SubsHistory.vue?vue&type=template&id=198808c5&scoped=true"
import script from "./SubsHistory.vue?vue&type=script&lang=js"
export * from "./SubsHistory.vue?vue&type=script&lang=js"
import style0 from "./SubsHistory.vue?vue&type=style&index=0&id=198808c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198808c5",
  null
  
)

export default component.exports